// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.delete-button,
.add-button {
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 50%;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 2rem;
}

.delete-button {
  background-color: #FEE2E2;
  color: #DC2626;
}

.add-button {
  background-color: #DCFCE7;
  color: #16A34A;
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 50%;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 2rem;
  position: relative;
}

.add-button:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.button-loader {
  width: 1.6rem;
  height: 1.6rem;
  border: 2px solid #16A34A;
  border-top: 2px solid transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

/* Animation pour le loader circulaire */
@keyframes spin {
  0% { 
    transform: rotate(0deg);
  }
  100% { 
    transform: rotate(360deg);
  }
}

/* Styles spécifiques pour les différents états de loading */
.add-button.loading {
  background-color: #DCFCE7;
  color: transparent; /* Cache le texte pendant le chargement */
}

.add-section .add-button.loading .button-loader {
  border-color: #16A34A;
  border-top-color: transparent;
}

/* Pour le bouton d'ajout d'article dans la ligne */
.add-article .add-button.loading .button-loader {
  border-color: #16A34A;
  border-top-color: transparent;
}

.sections-container {
  margin: 2rem 0;
}

.add-section {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 2rem;
}

.add-section input {
  padding: 1rem;
  width: 300px;
}

.section {
  margin-bottom: 2rem;
  border: 1px solid #E5E7EB;
  border-radius: 1rem;
  overflow: hidden;
}

.articles-list {
  padding: 1.2rem;
}

.article-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid #E5E7EB;
}

.article-item:last-child {
  border-bottom: none;
}

.add-article {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-top: 1rem;
}

.add-article input {
  padding: 1rem;
  width: 95%;
}

.add-article-button {
  width: 100%;
  padding: 1rem;
  background: none;
  border: 2px dashed #E5E7EB;
  border-radius: 0.4rem;
  color: #6B7280;
  cursor: pointer;
  margin-top: 1rem;
}

.add-article-button:hover {
  border-color: #DA7027;
  color: #DA7027;
}

.numero-article {
  width: 10rem;
}

.add-section h3 {
  font-size: 1.6rem;
}

.creation-article {
  display: flex;
  justify-content: space-between;
  gap: 2rem;
}

.creation-article p {
  width: 95%;
}

.loader {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #DA7027;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}

@keyframes spin {
  0% { transform: rotate(0deg);}
  100% { transform: rotate(360deg);}
}

.titre-article {
  display:flex;
  justify-content: space-between;
  background-color: rgba(194, 194, 194, 0.50);;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding: 1rem;
  color: #2C3948;
}

/* Ajustements pour le mode consultation des articles */
.view-mode .section {
  margin-bottom: 2rem;
}

.view-mode .section-header {
  display: flex;
  align-items: center;
}

.view-mode .section-header h3 {
  font-size: 1.6rem;
  margin: 0;
}

.empty-sections-message {
  padding: 2rem;
  background-color: #F3F4F6;
  border-radius: 0.5rem;
  text-align: center;
}

.step-container {
  padding: 2rem;
  margin: 0 auto;
}

.step-container h2 {
  font-size: 2.4rem;
  margin-bottom: 4rem;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/composants/CreationArticle/CreationArticle.css"],"names":[],"mappings":"AAAA;;EAEE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,iCAAiC;EACjC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA,wCAAwC;AACxC;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,4DAA4D;AAC5D;EACE,yBAAyB;EACzB,kBAAkB,EAAE,yCAAyC;AAC/D;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA,mDAAmD;AACnD;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,KAAK,uBAAuB,CAAC;EAC7B,OAAO,yBAAyB,CAAC;AACnC;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,2CAA2C;EAC3C,4BAA4B;EAC5B,6BAA6B;EAC7B,aAAa;EACb,cAAc;AAChB;;AAEA,uDAAuD;AACvD;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":[".delete-button,\n.add-button {\n  width: 2.4rem;\n  height: 2.4rem;\n  border-radius: 50%;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 2rem;\n}\n\n.delete-button {\n  background-color: #FEE2E2;\n  color: #DC2626;\n}\n\n.add-button {\n  background-color: #DCFCE7;\n  color: #16A34A;\n  width: 2.4rem;\n  height: 2.4rem;\n  border-radius: 50%;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 2rem;\n  position: relative;\n}\n\n.add-button:disabled {\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.button-loader {\n  width: 1.6rem;\n  height: 1.6rem;\n  border: 2px solid #16A34A;\n  border-top: 2px solid transparent;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n/* Animation pour le loader circulaire */\n@keyframes spin {\n  0% { \n    transform: rotate(0deg);\n  }\n  100% { \n    transform: rotate(360deg);\n  }\n}\n\n/* Styles spécifiques pour les différents états de loading */\n.add-button.loading {\n  background-color: #DCFCE7;\n  color: transparent; /* Cache le texte pendant le chargement */\n}\n\n.add-section .add-button.loading .button-loader {\n  border-color: #16A34A;\n  border-top-color: transparent;\n}\n\n/* Pour le bouton d'ajout d'article dans la ligne */\n.add-article .add-button.loading .button-loader {\n  border-color: #16A34A;\n  border-top-color: transparent;\n}\n\n.sections-container {\n  margin: 2rem 0;\n}\n\n.add-section {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 2rem;\n}\n\n.add-section input {\n  padding: 1rem;\n  width: 300px;\n}\n\n.section {\n  margin-bottom: 2rem;\n  border: 1px solid #E5E7EB;\n  border-radius: 1rem;\n  overflow: hidden;\n}\n\n.articles-list {\n  padding: 1.2rem;\n}\n\n.article-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem;\n  border-bottom: 1px solid #E5E7EB;\n}\n\n.article-item:last-child {\n  border-bottom: none;\n}\n\n.add-article {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n.add-article input {\n  padding: 1rem;\n  width: 95%;\n}\n\n.add-article-button {\n  width: 100%;\n  padding: 1rem;\n  background: none;\n  border: 2px dashed #E5E7EB;\n  border-radius: 0.4rem;\n  color: #6B7280;\n  cursor: pointer;\n  margin-top: 1rem;\n}\n\n.add-article-button:hover {\n  border-color: #DA7027;\n  color: #DA7027;\n}\n\n.numero-article {\n  width: 10rem;\n}\n\n.add-section h3 {\n  font-size: 1.6rem;\n}\n\n.creation-article {\n  display: flex;\n  justify-content: space-between;\n  gap: 2rem;\n}\n\n.creation-article p {\n  width: 95%;\n}\n\n.loader {\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #DA7027;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  animation: spin 1s linear infinite;\n  margin: 0 auto;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg);}\n  100% { transform: rotate(360deg);}\n}\n\n.titre-article {\n  display:flex;\n  justify-content: space-between;\n  background-color: rgba(194, 194, 194, 0.50);;\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n  padding: 1rem;\n  color: #2C3948;\n}\n\n/* Ajustements pour le mode consultation des articles */\n.view-mode .section {\n  margin-bottom: 2rem;\n}\n\n.view-mode .section-header {\n  display: flex;\n  align-items: center;\n}\n\n.view-mode .section-header h3 {\n  font-size: 1.6rem;\n  margin: 0;\n}\n\n.empty-sections-message {\n  padding: 2rem;\n  background-color: #F3F4F6;\n  border-radius: 0.5rem;\n  text-align: center;\n}\n\n.step-container {\n  padding: 2rem;\n  margin: 0 auto;\n}\n\n.step-container h2 {\n  font-size: 2.4rem;\n  margin-bottom: 4rem;\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
